import React, { useState } from "react";
import * as notify from "../../../shared/notify";
import classnames from "classnames";

import { ButtonSelect } from "../../form-inputs/inputs";

const PreviewShots = (props) => {
    const groupItem = props.groupShots.find((g) => g.groupCode === props.selected);

    if (!groupItem || !groupItem.imageViews) {
        return null;
    }

    const previews = groupItem.imageViews.map((item) => {
        const isNew = !props.usedShots.includes(item.shortName);
        const name = isNew ? <b>{item.name}</b> : item.name;

        return (
            <li
                key={item.shortName}
                className={classnames({ "-plus": isNew })}
            >
                {name}
            </li>
        );
    });

    return <ul className="additive -no-indent">{previews}</ul>;
};

const GroupShots = (props) => {
    const [selectedGroup, setSelectedGroup] = useState("");

    const addPlaceholder = () => {
        if (!selectedGroup) {
            notify.error("Please select a group from the list");

            return;
        }

        const groupItem = props.groupShots.find((g) => g.groupCode === selectedGroup);
        setSelectedGroup("");

        if (groupItem && groupItem.hasOwnProperty("imageViews")) {
            props.addPlaceholders(groupItem.imageViews);
        } else {
            notify.error("Selection does not have options");
        }
    };
    const updateField = (name, value) => {
        setSelectedGroup(value);
    };

    return (
        <div>
            <ButtonSelect
                options={props.groupShots}
                value={selectedGroup}
                label={props.label}
                updateOnChange={updateField}
                buttonClick={addPlaceholder}
                disabled={props.disabled}
            />
            <PreviewShots
                selected={selectedGroup}
                groupShots={props.groupShots}
                usedShots={props.usedShots}
            />
        </div>
    );
};

export default GroupShots;
